import useSWR from 'swr';
import { REFRESH_INTERVAL_BULK_TICKET_CHANGE_JOB_LIST } from '../../constants/swr-config';
import { customSWRConfig } from '../../model/types';
import { BulkTicketChangeJob } from '../../services/tickets/tickets';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useBulkTicketChangeJobList(jobList: string, config: customSWRConfig = {}) {
    const requestFlag = config?.requestFlag ?? true;

    const keys = useSWRCacheKeys(jobList && requestFlag ? `tickets/bulk-jobs?jobIds=${jobList}` : null);

    return useSWR<BulkTicketChangeJob[]>(keys, {
        refreshInterval: REFRESH_INTERVAL_BULK_TICKET_CHANGE_JOB_LIST,
        ...config
    });
}
